const dns_table = {
	/* -------------------------------------------------------------------------- */
	/*                               ERROR MESSAGES                               */
	/* -------------------------------------------------------------------------- */
	error_messages: {
		ERR_A_1:
			"Het ingevoerde IPv4-adres is ongeldig. Controleer of het in het juiste formaat is (bijvoorbeeld 192.168.1.1) en dat elk segment een getal tussen 0 en 255 is.",
		ERR_AAAA_1:
			"Het ingevoerde IPv6-adres is ongeldig. Zorg ervoor dat het in het juiste formaat is (bijvoorbeeld 2001:0db8:85a3:0000:0000:8a2e:0370:7334) en dat elk segment een hexadecimaal getal tussen 0000 en FFFF bevat.",
		ERR_CNAME_1: "Een CNAME-record mag geen @ als label hebben.",
		ERR_CNAME_2:
			"Een CNAME-record moet een geldig domeinnaam als waarde hebben en eindigen op een punt (.)",
		ERR_CNAME_3: "Label bestaat al voor andere CNAME-record.",
		ERR_LABEL_1: "Het huidige label is niet toegestaan.",
		ERR_MX_1:
			"Een MX-record moet een geldige domeinnaam als waarde hebben en eindigen op een punt (.)",
		ERR_NONE_1: "Het lijkt erop dat de ingevoerde DNS-gegevens niet kloppen.",
		ERR_NS_1: "Een NS-record mag geen @ als label hebben.",
		ERR_NS_2:
			"Een NS-record moet een geldige domeinnaam als waarde hebben en eindigen op een punt (.)",
		ERR_SRV_1: "Ongeldig label voor SRV-record: controleer of het label correct is ingevoerd.",
		ERR_SRV_2: "Ongeldig waarde voor SRV-record: controleer of de waarde correct is ingevoerd.",
		ERR_SRV_3: "Gewichts- en poortnummers moeten tussen 0 en 65535 liggen",
	},
	/* -------------------------------------------------------------------------- */
	/*                                   HEADER                                   */
	/* -------------------------------------------------------------------------- */
	header: {
		label: {
			label: "Label",
			tooltip:
				"Het domein of het subdomein dat wordt aangewezen. Gebruik @ voor je standaarddomein (zoals leukvoorbeeld.com). Voer de domeinnaam niet in dit veld in (oftewel www, niet www.leukvoorbeeld.com).",
		},
		priority: {
			label: "Prioriteit",
		},
		ttl: {
			label: "TTL",
			tooltip:
				"Aantal seconden dat de DNS-servers wachten totdat de record wordt vernieuwd. Een kortere TTL betekent snellere DNS-updates in de toekomst. Langere TTL's zorgen voor meer tolerantie en betere prestaties.",
		},
		type: {
			label: "Type",
			tooltip:
				"Het DNS type bepaald de vereisten en het gedrag van de record. Ieder DNS type geeft andere informatie door aan de DNS-server over het domein.",
		},
		value: {
			label: "Waarde",
			tooltip: "De bestemming van de record: de waarde varieert op basis van het type record.",
		},
	},

	/* -------------------------------------------------------------------------- */
	/*                                  TABLE ROW                                 */
	/* -------------------------------------------------------------------------- */
	row: {
		buttons: {
			cancel: "Annuleer",
			delete: "Verwijder",
			edit: "Wijzig",
			ok: "OK",
		},
		empty: "Geen DNS-records gevonden",
		label: {
			A: "Bijvoorbeeld @ of www",
			AAAA: "Bijvoorbeeld @ of www",
			CNAME: "Bijvoorbeeld api of blog",
			empty: "Leeg",
			MX: "Bijvoorbeeld @ of mail",
			NS: "Bijvoorbeeld @ of mail",
			none: "Bijvoorbeeld @ of www",
			SRV: "_xmpp._tcp.example.com.",
			TLSA: "_443._tcp.example.com.",
			TXT: "Bijvoorbeeld @ of mail",
		},
		type: {
			placeholder: "Type kiezen",
		},
		value: {
			A: "XX.XX.XX.XX",
			AAAA: "XX:XX:XX:XX:XX:XX:XX:XX",
			CNAME: "example.com",
			MX: "smtp.example.com",
			NS: "ns1.example.com",
			none: "XX.XX.XX.XX",
			SRV: "0 0000 service.example.com.",
			TLSA: "0 0 0 d2abde240d7cd3ee6b4b28c54df034b97983a1d16e8a410e4561cb106618e971",
			TXT: "Een tekstuele waarde",
		},
	},
};

export default dns_table;
